/** Server epoch time advanced by a monotonic clock, independent of wall-clock changes. */
export class ServerClock {
  private anchor: Readonly<{ serverTime: number; monotonicTime: number }> | undefined;

  constructor(
    private readonly wallNow: () => number = Date.now,
    readonly monotonicNow: () => number = () => performance.now(),
  ) {}

  synchronize(serverTime: number | undefined): void {
    if (serverTime === undefined) return;
    const monotonicTime = this.monotonicNow();
    // The first server sample must replace even a wildly incorrect local fallback.
    // Delayed or repeated samples must never rewind an established server clock.
    this.anchor = {
      serverTime:
        this.anchor === undefined
          ? serverTime
          : Math.max(serverTime, this.estimatedTime(monotonicTime)),
      monotonicTime,
    };
  }

  now(): number {
    return this.anchor === undefined ? this.wallNow() : this.estimatedTime(this.monotonicNow());
  }

  private estimatedTime(monotonicTime: number): number {
    const anchor = this.anchor;
    if (anchor === undefined) return this.wallNow();
    return anchor.serverTime + Math.max(0, monotonicTime - anchor.monotonicTime);
  }
}
